/**
 * Moduł do zarządzania statusem mobilnym
 *
 * @export
 * @class MobileModule
 */
export class LayoutModule {
  /**
   * Domyślny stan modułu
   *
   * @private
   * @memberof LayoutModule
   */
  private defaultState = {
    isFiltering: undefined
  };

  /**
   * Stan modułu
   *
   * @memberof LayoutModule
   */
  public state = {
    ...this.defaultState
  };

  public mutations = {
    saveNavFilter(localState: any, payload: any) {
      localState.isFiltering = payload;
    }
  };

  public actions = {
    setNavFilter(context: any, value: any) {
      context.commit('saveNavFilter', value);
    }
  };

  public getters = {};
}

export default new LayoutModule();
